import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook, Star } from 'lucide-react';
import { business, navLinks, services } from '../mock';

const socials = [
  { label: 'Facebook', icon: Facebook, href: '#' },
  { label: 'Instagram', icon: Instagram, href: '#' },
];

export default function Footer() {
  return (
    <footer style={{ backgroundColor: 'var(--forest-deep)' }}>
      <div className="container-x py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
          <div className="flex items-center mb-5">
            <img src="/brand-logo-white.png" alt={`${business.name} ${business.nameLine2}`} className="h-[64px] w-auto" style={{ objectFit: 'contain' }} />
          </div>
            <p className="text-white/60 text-[15px] max-w-[300px]">
              Inspired in-home care for the seniors you love, across the Dallas &amp; Fort Worth
              metroplex since {business.since}.
            </p>
            <div className="flex items-center gap-2.5 mt-5" data-testid="footer-rating">
              <div className="flex items-center gap-1">
                {[0, 1, 2, 3, 4].map((i) => (
                  <Star key={i} size={18} style={{ color: 'var(--service-yellow)' }} fill="var(--service-yellow)" />
                ))}
              </div>
              <span className="text-white/70 text-sm">5-Star Rated</span>
            </div>
            <div className="flex items-center gap-3 mt-6">
              {socials.map((s) => {
                const Icon = s.icon;
                return (
                  <a
                    key={s.label}
                    href={s.href}
                    aria-label={s.label}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center rounded-full transition-all duration-200 hover:-translate-y-0.5"
                    style={{ width: 40, height: 40, backgroundColor: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.14)' }}
                  >
                    <Icon size={18} style={{ color: 'var(--sage)' }} />
                  </a>
                );
              })}
            </div>
          </div>

          <div>
            <h4 className="text-white text-base mb-4" style={{ color: '#fff' }}>Explore</h4>
            <ul className="flex flex-col gap-3">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-white/60 hover:text-white transition-colors text-[15px]">{l.label}</a>
                </li>
              ))}
              <li><Link to="/service-areas" className="text-white/60 hover:text-white transition-colors text-[15px]">Service Areas</Link></li>
              <li><Link to="/careers" className="text-white/60 hover:text-white transition-colors text-[15px]">Careers</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-base mb-4" style={{ color: '#fff' }}>Care Services</h4>
            <ul className="flex flex-col gap-3">
              {services.slice(0, 6).map((s) => (
                <li key={s.id}>
                  <a href="#services" className="text-white/60 hover:text-white transition-colors text-[15px]">{s.title}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white text-base mb-4" style={{ color: '#fff' }}>Get in Touch</h4>
            <ul className="flex flex-col gap-3">
              <li>
                <a href={business.phoneHref} className="flex items-center gap-3 text-white/60 hover:text-white transition-colors text-[15px]">
                  <Phone size={17} style={{ color: 'var(--sage)' }} /> {business.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${business.email}`} className="flex items-center gap-3 text-white/60 hover:text-white transition-colors text-[15px]">
                  <Mail size={17} style={{ color: 'var(--sage)' }} /> {business.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/60 text-[15px]">
                <MapPin size={17} style={{ color: 'var(--sage)' }} /> {business.area}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" style={{ borderTop: '1px solid rgba(255,255,255,0.12)' }}>
          <p className="text-white/50 text-sm">
            &copy; {new Date().getFullYear()} {business.name} {business.nameLine2}. All rights reserved.
          </p>
          <p className="text-white/50 text-sm">
            Designed by{' '}
            <a href="https://mozeid.com/" target="_blank" rel="noopener noreferrer" className="font-semibold hover:underline" style={{ color: 'var(--sage)' }}>
              Mo Studio
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
